import { RelatedLinksMocks } from '@com-delta-idp/mnx-skymiles-shared';
import { OffersMocks } from '../../../features';
import { Earns } from '../models/earns.interfaces';
import { BannerMocks } from './banner.mocks';

export const EarnsMocks: Earns = {
  title: 'Earn Miles and More',
  banner: BannerMocks,
  offers: OffersMocks,
  partners: true,
  relatedLinks: RelatedLinksMocks
};
